export default __webpack_public_path__ + "static/media/venly.b8394f68.svg";